<template>
    <div class="container">
        <div class="row">
            <div class="container-fluid">
                <h3 class="title">MES LOISIRS</h3>

	<div v-for="(value, key) in loisirs" :key="key" class="maj_comp">
          <h4>{{ key.toUpperCase() }}</h4>        
		<div v-for="(competence, index) in value" :key="index" class="div_card">
			<img class="icone" :src="getImg(competence.img)" alt="Image non trouvée">
			<div>
				<h5 class="title_comp">{{ competence.nom }}</h5>
			</div>
		</div>
	</div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Loisirs",
        props: ["loisirs"],
	methods: {
            getImg(img) {
                return require('../../public/img/' + img);
            }
        }
}
</script>

<style>
.maj_comp {
	display: inline-block;
	position: relative;
}

.div_card {
	display: inline-block;
	margin: 15px;
	padding: 20px;
	box-shadow: 0px 5px 25px 0px rgba(0,0,0,0.2);
}

.title_comp {
	margin: 0px;
	padding: 5px;
}

img {
	margin:auto;
}
</style>
